// Drop-in replacement for the echarts-for-react default export that binds
// to the tree-shaken echarts instance in echartsShared. Using the default
// package entry pulls in the full ~1 MB echarts bundle; this wrapper uses
// the /lib/core build which leaves bundling of echarts to us.
import React from "react";
import EChartsReactCore from "echarts-for-react/lib/core";
import type { EChartsReactProps } from "echarts-for-react/lib/types";
import { echarts } from "./echartsShared";

type Props = Omit<EChartsReactProps, "echarts">;

const EChartsReact = React.forwardRef<EChartsReactCore, Props>((props, ref) => (
	<EChartsReactCore ref={ref} echarts={echarts} {...props} />
));

EChartsReact.displayName = "EChartsReact";

export default EChartsReact;